<script>
export default {
    name: "TrueFalseQuestion",
    data() {
        return {
            selectedOption: null,
        }
    },
    methods: {
        checkAnswer() {
            this.$emit('checkInput', this.selectedOption)
        }
    },
    props: {
        question: {
            type: Object,
            required: true
        },
        buttonLabel: {
            type: String,
            default: 'Check Answer'
        }
    }
}
</script>

<template>
    <div>
        <div class="form-check">
            <input
                class="form-check-input"
                type="radio"
                :name="`question-${question.id}`"
                :value="true"
                :id="`question-${question.id}-true`"
                v-model="selectedOption"
            >
            <label class="form-check-label" :for="`question-${question.id}-true`">True</label>
        </div>
        <div class="form-check">
            <input
                class="form-check-input"
                type="radio"
                :name="`question-${question.id}`"
                :value="false"
                :id="`question-${question.id}-false`"
                v-model="selectedOption"
            >
            <label class="form-check-label" :for="`question-${question.id}-false`">False</label>
        </div>
        <button type="button" class="btn btn-secondary" @click="checkAnswer()">{{buttonLabel}}</button>
    </div>
</template>
